// extracted by mini-css-extract-plugin
module.exports = {"container":"Industries-Industries-container-a73bb67d","headline":"Industries-Industries-headline-f8555525","industry":"Industries-Industries-industry-f091f4e5"};